export const getters = {
  getApplication: (state) => {
    return state[state.activeApplication];
  },
  getApplicationId: state => (appType) => {
    return state[appType].ua_icapplicationid;
  },
  getApplicationName: state => {
    return state.application?.ua_businessname ?? '';
  },
  getApplicationStatus: state => (appType) => {
    return state[appType].ua_currentstatus;
  },
  getAppSubmitted: state => (appType) => {
    return state[appType].ua_submitapplication;
  },
  getApplicationCurrentStep: state => (appType) => {
    return state[appType].ua_currentpageinapplication;
  },
  getParentEmployeesOpts: (state) => {
    const numberOfEmployeesOpts = [
      { label: '1', value: '1' },
      { label: '2-4', value: '2' },
      { label: '5-9', value: '4' },
      { label: '10-19', value: '3' },
      { label: '20-49', value: '8' },
      { label: '50-99', value: '6' },
      { label: '100-249', value: '7' }
    ];
    const minItemIndex = numberOfEmployeesOpts.findIndex(option => option.value === state.ua_companyemployeeslist);
    const parentOpts = minItemIndex > -1 ? numberOfEmployeesOpts.splice(minItemIndex) : numberOfEmployeesOpts;

    return parentOpts;
  },
  getActiveApplication: state => {
    // returns 'small' or 'large'
    const activeApplication = state.activeApplication;
    if (!activeApplication) {
      return false;
    }
    return activeApplication;
  }
};
